/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import '../css/ordersTable.css';
import InvoiceIcon from '../Icons/InvoiceIcon.js';
import EditOrderForm from './EditOrderForm.js';
import GenerateInvoiceModal from './GenerateInvoiceModal.js'; // Import GenerateInvoiceModal
import CompanyInfoModal from './CompanyInfoModal'; // Import the CompanyInfoModal component
import { ref, update, get } from 'firebase/database';
import { db, db2, db3 } from '../firebase.js';
import InvoiceMultipleModal from './GenerateInvoiceOAMultipleModal.js';
import Invoice from './GeneratePDFInvoice.js';
import { addInvoiceToAnalytics } from '../utils/analyticsDb';

const OrdersTable = ({ user, userRole, orders, vendor }) => {
  const [previewUrl, setPreviewUrl] = useState('');
  const [editingOrder, setEditingOrder] = useState(null);
  const [showGenerateInvoiceModal, setShowGenerateInvoiceModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [companyInfo, setCompanyInfo] = useState(null);
  const [showCompanyInfoModal, setShowCompanyInfoModal] = useState(false);
  const [showMultipleInvoiceModal, setShowMultipleInvoiceModal] = useState(false);
  const [showOffer, setShowOffer] = useState(false);
  const [isLoadingCompany, setIsLoadingCompany] = useState(false);

  const handleEditOrder = (order) => {
    setEditingOrder(order);
  };

  const handleCloseModal = () => {
    setEditingOrder(null);
  };

  const handleSendToDebtors = async (order) => {
    try {
      if (!order.validatedInvoice) {
        alert("Нарачката ги нема сите инфромации за фактура. ве молам потврдете дека се е во ред");
        return;
      }

      // Update order status to 'Invoiced'
      const orderRef = ref(db, `orders/${order.id || order.firebaseID || order.OrderID || order.OrdderID}`);
      const orderSnapshot = await get(orderRef);
      const currentOrder = orderSnapshot.val();

      console.log('Current order:', currentOrder);
      
      if (!currentOrder) {
        throw new Error('Order not found');
      }

      if (!currentOrder.Buyer) {
        throw new Error('Buyer name not found in order');
      }

      // Add to analytics DB (DB3)
      console.log('Adding to analytics DB:', currentOrder);
      const result = await addInvoiceToAnalytics(currentOrder);
      
      if (!result) {
        throw new Error('Failed to add invoice to analytics');
      }

      // Update order status
      console.log('Updating order status to Invoiced');
      await update(orderRef, {
        Status: "Invoiced",
      });
      console.log('Order status updated successfully');

      if (order.derivativeOrders) {
        for (const derivativeOrder of order.derivativeOrders) {
          if (!derivativeOrder.validatedInvoice) {
            alert("Ве молам потврдете дека сите под-нарачки имаат фактури и информациите за нив се точно пополнети");
            return;
          }
        }

        // Update all derivative orders
        console.log('Processing derivative orders');
        for (const derivativeOrder of order.derivativeOrders) {
          const derivativeRef = ref(db, `orders/${derivativeOrder.id || derivativeOrder.firebaseID || derivativeOrder.OrderID}`);
          const derivativeData = {
            ...currentOrder,
            id: derivativeOrder.id || derivativeOrder.firebaseID || derivativeOrder.OrderID,
            total_amount: derivativeOrder.total_amount || derivativeOrder.TotalAmount,
            Buyer: currentOrder.Buyer // Ensure buyer name is passed
          };

          console.log('Updating derivative order:', derivativeOrder.id);
          await update(derivativeRef, {
            Status: "Invoiced",
          });
          console.log('Derivative order updated');

          // Add derivative order to analytics
          console.log('Adding derivative to analytics DB:', derivativeData);
          const derivativeResult = await addInvoiceToAnalytics(derivativeData);
          if (!derivativeResult) {
            throw new Error('Failed to add derivative invoice to analytics');
          }
        }
      }

      alert("Успешно ажурирани нарачки");
    } catch (error) {
      console.error('Error sending order to debtors:', error);
      alert("Грешка при ажурирање на нарачките: " + error.message);
    }
  };

  const handleGenerateInvoice = async (order) => {
    try {
      setSelectedOrder(order);
      setShowGenerateInvoiceModal(true);
      // Add to analytics DB
      await addInvoiceToAnalytics(order);
    } catch (error) {
      console.error('Error generating invoice:', error);
    }
  };

  const handleMultipleInvoiceModal = async (order) => {
    try {
      setSelectedOrder(order);
      setShowMultipleInvoiceModal(true);
      // Add to analytics DB
      await addMultipleInvoicesToAnalytics([order]);
    } catch (error) {
      console.error('Error generating multiple invoices:', error);
    }
  };

  const handleCloseMultipleInvoiceModal = () =>{
    setSelectedOrder(null);
    setShowMultipleInvoiceModal(false);
  }
  const handleCloseGenerateInvoiceModal = () => {
    setShowGenerateInvoiceModal(false);
    setSelectedOrder(null);
  };

  const handlePreviewInvoice = (invoiceLink) => {
    setPreviewUrl(invoiceLink);
  };

  const handleClosePreview = () => {
    setPreviewUrl('');
  };

  const handleCreateOffer= (order) => {
    setSelectedOrder(order);
    setShowOffer(true)
  };

  const handleCloseOffer= () =>{
    setSelectedOrder(null);
    setShowOffer(false);
  }

  const handleOpenCompanyInfo = async (buyerName, BuyerID = "") => {
    setIsLoadingCompany(true);
    try {
      const companiesRef = ref(db2, 'companies');
      const snapshot = await get(companiesRef);
      if (snapshot.exists()) {
        const companies = snapshot.val();
        const companyList = Object.values(companies);
        const foundCompany = companyList.find(company => (BuyerID ? company.id === BuyerID : company.ime === buyerName));
        if (foundCompany) {
          setCompanyInfo(foundCompany);
          setShowCompanyInfoModal(true);
        } else {
          console.log('Фирма не е пронајдена');
        }
      } else {
        console.log('Нема податоци за фирмите');
      }
    } catch (error) {
      console.error('Проблем при вчитување на фирмите:', error);
    } finally {
      setIsLoadingCompany(false);
    }
  };

  return (
    <div className="orders-table-container">
      {isLoadingCompany && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>
      )}
      <h2>{vendor}</h2>
      {previewUrl && (
        <div className="invoice-preview">
          <div className="preview-content">
            <button className="close-button" onClick={handleClosePreview}>&times;</button>
            <iframe src={previewUrl} title="Invoice Preview" className="preview-frame"></iframe>
          </div>
        </div>
      )}
      {selectedOrder && showOffer && (
        <div className="invoice-preview">
          <div className="preview-content">
            <div className="offer-doc-container">
              <button className="close-button" onClick={handleCloseOffer}>&times;</button>
              <Invoice documentType="Понуда" order={selectedOrder} />
            </div>
          </div>
        </div>
      )}
      <table className="orders-table orders-table-1">
        <thead>
          <tr>
            <th>Број на нарачка</th>
            <th>Датум - нарачка</th>
            <th>ОА Број</th>
            <th>д. Испорака</th>
            <th>д. Уплата</th>
            <th>Купец</th>
            <th>Коментари</th>
            <th>Док.</th>
            <th>Фирма</th>
            <th>Одговорно Лице</th>
            <th>Аванс Сума</th>
            {userRole === "admin" && <th>Подеси</th>}
          </tr>
        </thead>
        <tbody>
          {orders.map((baseOrder) => (
            <React.Fragment key={baseOrder.id}>
              {/* Base Order Row */}
              <tr className="base-order-row">
                <td>
                    <a className='order-link' href="#" onClick={() => handleEditOrder(baseOrder)}>
                      {baseOrder.OrderID}
                    </a>
                </td>
                <td>{baseOrder.OrderDate}</td>
                <td>
                  {userRole === "admin" ? (
                    <a className='order-link' href="#" onClick={() => handleMultipleInvoiceModal(baseOrder)}>
                      {baseOrder.OriginationNumber}
                    </a>
                  ) : (
                    baseOrder.OriginationNumber
                  )}
                </td>
                <td>{baseOrder.DateOfDelivery}</td>
                <td>{baseOrder.DateOfPayment}</td>
                <td>
                  <a className='order-link' href="#" onClick={() => handleOpenCompanyInfo(baseOrder.Buyer, baseOrder.BuyerID)}>
                    {baseOrder.Buyer}
                  </a>
                </td>
                <td>{baseOrder.Comment}</td>
                <td>
                  
                  {baseOrder.OtherLink !== '' && (
                    <button onClick={() => handlePreviewInvoice(baseOrder.OtherLink)}>
                      <InvoiceIcon />
                    </button>
                  )}
                  {baseOrder.orderItems && baseOrder.orderItems.length > 0 && (
                    <button onClick={() => handleCreateOffer(baseOrder)}>
                      <strong>П</strong>
                    </button>
                  )}
                </td>
                <td>{baseOrder.Jurisdiction}</td>
                <td>{baseOrder.Username}</td>
                <td>{baseOrder.Advance}</td>
                {userRole === "admin" && !baseOrder.validatedInvoice &&(
                  <td>
                    <button onClick={() => handleGenerateInvoice(baseOrder)}>+</button>
                  </td>
                )}
                {(userRole === "admin" && baseOrder.validatedInvoice && (
                  <td>
                     <button onClick={() => handleSendToDebtors(baseOrder)}>→</button>
                  </td>
))}
              </tr>

              {/* Derivative Order Rows */}
              {baseOrder.derivativeOrders?.map((derivativeOrder) => (
                <tr key={derivativeOrder.id} className="derivative-order-row">
                  <td>
                    <span className="derivative-arrow">↳</span>
                    {derivativeOrder.OrderID}
                  </td>
                  <td>{derivativeOrder.OrderDate}</td>
                  <td>{derivativeOrder.OriginationNumber}</td>
                  <td>{derivativeOrder.DateOfDelivery}</td>
                  <td>{derivativeOrder.DateOfPayment}</td>
                  <td>
                  <a className='order-link' href="#" onClick={() => handleOpenCompanyInfo(derivativeOrder.Buyer, derivativeOrder.BuyerID)}>
                        {derivativeOrder.Buyer}
                      </a>
                  </td>
                  <td>{derivativeOrder.Comment}</td>
                  <td>
                    {derivativeOrder.OtherLink !== '' && (
                      <button onClick={() => handlePreviewInvoice(derivativeOrder.OtherLink)}>
                        <InvoiceIcon />
                      </button>
                    )}
                    {derivativeOrder.orderItems && derivativeOrder.orderItems.length > 0 && (
                      <button onClick={() => handleCreateOffer(derivativeOrder)}>
                        <strong>П</strong>
                      </button>
                    )}
                  </td>
                  <td>{derivativeOrder.Jurisdiction}</td>
                  <td>{derivativeOrder.Username}</td>
                  <td>{derivativeOrder.Advance}</td>
                  {userRole === "admin" && !derivativeOrder.validatedInvoice &&(
                  <td>
                    <button onClick={() => handleGenerateInvoice(derivativeOrder)}>+</button>
                  </td>
                )}

                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      {editingOrder && (
        <EditOrderForm
        userRole={userRole}
          order={editingOrder}
          user={user}
          onClose={handleCloseModal}
        />
      )}
      {showGenerateInvoiceModal && (
        <GenerateInvoiceModal
          currentOrderID={selectedOrder.OrderID}
          order={selectedOrder}
          onClose={handleCloseGenerateInvoiceModal}
        />
      )}
      {showMultipleInvoiceModal && (
        <InvoiceMultipleModal
          ordersOANum={selectedOrder.OriginationNumber}
          onClose={handleCloseMultipleInvoiceModal}
        />
      )}
      {showCompanyInfoModal && companyInfo && (
        <CompanyInfoModal
          company={companyInfo}
          onClose={() => setShowCompanyInfoModal(false)}
        />
      )}
    </div>
  );
};

export default OrdersTable;
